"use strict";
// @ts-nocheck
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
var React = __importStar(require("react"));
;
function ssv(_a) {
    var size = _a.size, _b = _a.color, color = _b === void 0 ? "currentColor" : _b;
    return React.createElement("svg", { width: size, height: size, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { opacity: 0.62, d: "M177.641 404.919L242.226 325.315C248.972 316.999 261.661 316.999 268.407 325.315L332.991 404.919C338.013 411.108 338.013 419.97 332.991 426.16L268.407 505.764C261.661 514.079 248.972 514.079 242.226 505.764L177.641 426.16C172.62 419.97 172.62 411.108 177.641 404.919Z", fill: color }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M242.226 6.23638L177.641 85.8404C172.62 92.0303 172.62 100.892 177.641 107.082L242.226 186.686C248.972 195.001 261.661 195.001 268.407 186.686L332.991 107.082C338.013 100.892 338.013 92.0303 332.991 85.8404L268.407 6.23639C261.661 -2.07879 248.972 -2.0788 242.226 6.23638ZM76.7665 210.257L141.351 130.653C148.097 122.338 160.786 122.338 167.532 130.653L232.116 210.257C237.138 216.447 237.138 225.308 232.116 231.498L167.532 311.102C160.786 319.417 148.097 319.417 141.351 311.102L76.7665 231.498C71.7445 225.308 71.7445 216.447 76.7665 210.257ZM278.579 210.257L343.163 130.653C349.91 122.338 362.598 122.338 369.344 130.653L433.929 210.257C438.951 216.447 438.951 225.308 433.929 231.498L369.344 311.102C362.598 319.417 349.91 319.417 343.163 311.102L278.579 231.498C273.557 225.308 273.557 216.447 278.579 210.257Z", fill: color }));
}
exports["default"] = ssv;
//# sourceMappingURL=ssv.js.map